<template>
  <div>
    <div class="over-mask" v-if="overlayShow && visible" @click="emits('close')"></div>
    <div v-if="visible" class="timer-wrapper">
      <div class="title">{{ $t('serviceOutlets.business_hours') }}</div>
      <div class="content">
        <svg-icon name="ic_close_new" class="icon-close-time" @click="emits('close')" />
        <div class="left-block">
          <div
            :class="[{ active: selectedIndex === item.weekNum }, 'week-item']"
            v-for="(item, index) in info"
            :key="index"
            @click="selectDateClick(item)">
            {{ item?.week }}
          </div>
        </div>
        <div class="right-block">
          <div
            v-if="info.find((it:any) => it.weekNum === selectedIndex)?.opening == 1"
            class="tips">
            {{ $t('serviceOutlets.store_close_tip') }}
          </div>
          <template v-else>
            <div
              v-for="(item, index) in info.find((it:any) => it.weekNum === selectedIndex)?.calendList"
              :key="index"
              class="time">
              {{ item }}
            </div>
            <div class="tips">
              {{ $t('serviceOutlets.time_tip') }}
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
const { $sensorTrack } = useNuxtApp();

const props = defineProps({
  info: {
    type: Array,
    required: true,
    default: () => Array<any>()
  },
  allInfo: {
    type: Object,
    required: true,
    default: () => ({})
  },
  visible: {
    type: Boolean,
    default: false
  },
  overlayShow: {
    type: Boolean,
    default: false
  }
});
const selectedIndex = ref(0);
onMounted(() => {
  let week = new Date().getDay();
  if (week === 0) week = 7;
  selectedIndex.value = week;
});
const emits = defineEmits(['close']);

const selectDateClick = (item: any) => {
  selectedIndex.value = item.weekNum;
  $sensorTrack('overseas_service_store_details_moretime_day_click', {
    overseas_service_store_details_moretime_day: item.week,
    store_name: props.allInfo.storeName,
    store_id: props.allInfo.id
  });
};
</script>
<style lang="scss" scoped>
.over-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.5);
}
.timer-wrapper {
  position: absolute;
  z-index: 4000;
  background: #fff;
  border-radius: 20px;
  .title {
    padding: 15px 38px;
    color: #1e253d;
    font-size: 18px;
    font-weight: 500;
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.15);
  }
  .content {
    display: flex;
    flex-direction: row;
    height: 400px;
    position: relative;
    .icon-close-time {
      position: absolute;
      left: 90%;
      top: -50px;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    .left-block {
      background-color: #eff0f3;
      border-bottom-left-radius: 15px;
      .active.week-item {
        background-color: #fff;
        opacity: 1;
      }
      .week-item {
        cursor: pointer;
        color: #1e253d;
        font-size: 14px;
        width: 100px;
        height: 20px;
        line-height: 20px;
        padding: 10px 20px;
        opacity: 0.6;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .right-block {
      height: 300px;
      width: 175px;
      padding: 10px 20px;
      .time {
        color: #1e253d;
        font-size: 14px;
        margin-bottom: 20px;
      }
      .tips {
        font-size: 12px;
        color: #1e253d;
        opacity: 0.6;
      }
    }
  }
}
</style>
